import React from 'react';
import { XMarkIcon, DocumentTextIcon } from '@heroicons/react/24/solid';
import EmbeddedNotepadNoteCard from './EmbeddedNotepadNoteCard';
import SpinnerLoad from 'views/notepad/moduleComponents/spinner_load';

const EmbeddedNotepadNotePicker = ({
  isOpen,
  onClose,
  notes,
  isLoading,
  onSelect,
  title = 'Link note',
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="fixed inset-0 z-[90] bg-black/40"
        onClick={onClose}
        aria-hidden="true"
      />
      <div
        className="fixed inset-x-4 top-1/2 z-[100] mx-auto max-h-[80vh] w-full max-w-lg -translate-y-1/2 overflow-hidden rounded-2xl bg-white shadow-2xl"
        role="dialog"
        aria-modal="true"
        aria-labelledby="embedded-notepad-picker-title"
      >
        <div className="flex items-center justify-between border-b border-gray-200 px-4 py-3">
          <h3 id="embedded-notepad-picker-title" className="text-base font-semibold text-gray-800">
            {title}
          </h3>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-1.5 text-gray-500 hover:bg-gray-100"
            aria-label="Close"
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>

        <div className="max-h-[calc(80vh-56px)] overflow-y-auto p-3">
          {isLoading && notes.length === 0 ? (
            <div className="flex items-center justify-center py-12">
              <SpinnerLoad />
            </div>
          ) : notes.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-10 text-center">
              <DocumentTextIcon className="mb-3 h-12 w-12 text-gray-300" />
              <p className="text-sm text-gray-500">No notes available. Create notes in Notepad first.</p>
            </div>
          ) : (
            <div className="flex flex-col gap-2">
              {notes.map((note) => (
                <EmbeddedNotepadNoteCard
                  key={note.id}
                  note={note}
                  viewMode="title-only"
                  onClick={() => onSelect(note)}
                />
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EmbeddedNotepadNotePicker;
